import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../../theme/Component/Modal';
import { _WelfareEntity } from '../../../../../../core/services/dataBean/EntityCatalogVdos';
import { toast } from 'react-toastify';
import { BasicTable } from '../../../../../theme/Component/BasicTable';
import usePaginator from '../../../../../theme/Component/usePaginator';
import { BasicButton } from '../../../../../theme/Component/BasicButton';
import { WelfareEntityTypeEditor } from '../../../../ParametrosTalentoHumano/EmployeeBonus/Editors/WelfareEntityType.Editor';
import { WelfareEntityTypeConstantsSelector } from '../../../../ParametrosTalentoHumano/ImportedPayrollBeneficiary/WelfareEntityTypeConstants';


interface Props {
    entity?: number,
    idSelector: number;
    onChange: any;
    label?: string;
}

export const WelfareEntityEditor = ({ entity, idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_WelfareEntity)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});
    const paginador = usePaginator();
    const [contanst, setconstansts] = useState<any>(null)
    const [tipe, settipe] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)

    useEffect(() => {
        if (entity) {
            getLista();
        }
    }, [entity])


    const getLista = () => {

        instance.getWelfareEntityCatalogByType(contanst, tipe, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    setLista(resp.List)
                }
            }
        )

    }

    const returnValue = () => {
        if (obj.IDWelfareEntity) {
            setValor(`${obj.IDWelfareEntity ?? ""} - ${obj.Code} - ${obj.AccountName}`)
            setModal({ ...modal, "view": false });
            onChange(obj);
        } else {
            toast.error("Producto no valido")
        }
    }

    const head = [
        { title: 'ID', property: 'IDWelfareEntity', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Tipo de Entidad', property: 'WelfareEntityTypeName', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
    ]

    return (
        <>
            <label>{label ?? "Entidad de Bienestar"}</label>
            <div
                className={`form-control text-wrap cursor-pointer`}
                style={{ minHeight: '35px' }}
                onClick={() => { setModal({ ...modal, view: true }); }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={returnValue}>
                <div className="row">

                    <div className="col-md-4">
                        <WelfareEntityTypeConstantsSelector label='Tipo' idSelector={contanst} onChange={(e) => { setconstansts(e) }} />
                    </div>
                    <div className="col-md-4">
                        <WelfareEntityTypeEditor idSelector={tipe} onChange={(e) => { settipe(e) }} label="Tipo de Entidad" />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton value="Buscar por Filtros*" icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                    </div>
                    <div className="col-md-12">

                        <BasicTable body={lista} head={head} rowSet={setObj} />
                    </div>
                </div>
            </Modal>
        </>
    )
}